export default __webpack_public_path__ + "static/media/mnm.ed71e777.webp";